// extracted by mini-css-extract-plugin
export var body = "_nz-8";
export var button = "_nz-0";
export var closeButton = "_nz-5";
export var content = "_nz-3";
export var empty = "_nz-f";
export var grid = "_nz-c";
export var header = "_nz-4";
export var icon = "_nz-1";
export var option = "_nz-d";
export var optionSelected = "_nz-e";
export var overlay = "_nz-2";
export var searchIcon = "_nz-a";
export var searchInput = "_nz-b";
export var searchWrapper = "_nz-9";
export var title = "_nz-6";
export var visuallyHidden = "_nz-7";